module.exports = __webpack_public_path__ + "static/media/usn-3.468b846b.jpg";